/* @flow */
import { em } from 'polished';

export default {
  root: {
    width: em(15),
    height: em(15),
  },
};
